<template lang="pug">
.d-flex.align-center
  v-text-field(
    :value="value"
    hide-details
    outlined
    label="Job title",
    )
  v-dialog(v-model="dialog" max-width='1600')
    template(v-slot:activator="{ on, attrs }")
      v-btn.ml-2(color="primary" v-bind="attrs" v-on="on") Select job title
    v-card
      v-card-title.headline
        |Select job title
      v-card-text
        JobTitleAnswerBlock(v-model="result" @input="answer")
      v-card-actions
        v-spacer
        v-btn(@click="closeDialog") Cancel
</template>

<script>
import JobTitleAnswerBlock from '@/components/Quiz/AnswerBlock/Blocks/JobTitles.vue'
export default {
  components: { JobTitleAnswerBlock },
  props: ['value'],
  data: () => ({
    dialog: false,
    result: ''
  }),
  methods: {
    answer() {
      this.$emit('input', this.result)
      this.dialog = false
    },
    closeDialog() {
      this.dialog = false
    }
  }
}
</script>

<style scoped lang="sass">

</style>